import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { ResponseIssuesOrganization } from 'src/core/store/ducks/issuances/types'

type Props = {
  items: ResponseIssuesOrganization[]
  loading: boolean
  onChange(values: {
    customer_organization_id: string
    customer_tenant_id: string
  }): void
  style?: { [key: string]: string | number }
}
const defaultStyle = { margin: '16px 8px', minWidth: 200 }

export default function RequestOrganizationFilter({
  items = [],
  loading,
  onChange,
  style = defaultStyle
}: Props) {
  const { t } = useTranslation()

  return (
    <Select
      allowClear
      data-test-id="request-organization-list"
      loading={loading}
      onChange={values => {
        const foundRecord = items.find(
          item => item.organization_id.toString() === values
        )
        onChange({
          customer_tenant_id: foundRecord?.tenant_id.toString() || '',
          customer_organization_id:
            foundRecord?.organization_id.toString() || ''
        })
      }}
      placeholder={t('web.organization.title')}
      style={style}
    >
      {items.map(organization => (
        <Select.Option
          data-test-id={`request-organization-item-${organization.organization_id}`}
          key={organization.organization_id.toString()}
          label={organization.trade_name}
          title={organization.trade_name}
          value={organization.organization_id.toString()}
        >
          {organization.trade_name}
        </Select.Option>
      ))}
    </Select>
  )
}
